import type { TranslationKey } from "@qualtio-workhub/i18n";

export function getGithubPullRequestUrlError(value: string): TranslationKey | null {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return null;
  }

  try {
    const parsed = new URL(trimmed);
    const isGithubHost = parsed.hostname === "github.com" || parsed.hostname === "www.github.com";
    const isHttp = parsed.protocol === "https:" || parsed.protocol === "http:";
    const isPullRequestPath = /^\/[^/]+\/[^/]+\/pull\/\d+\/?$/.test(parsed.pathname);
    return isGithubHost && isHttp && isPullRequestPath ? null : "github.prUrlInvalid";
  } catch {
    return "github.prUrlInvalid";
  }
}
